import { Form, Modal } from "antd";
import React, { memo, useCallback } from "react";
import update from "immer";
import moment from "moment";
import omit from "lodash/omit";

import BienKSXe from "../conponents/BienKSXe";
import ChiNhanhXe from "../conponents/ChiNhanhXe";
import LoaiHopDong from "../conponents/LoaiHopDong";
import SelectMonth from "../conponents/SelectMonth";
import SoHopDong from "../conponents/SoHopDong";
import TaiXe from "../conponents/TaiXe";

const OverKmReportModal = ({ onCancel, onOk, visible }) => {
  const [form] = Form.useForm();

  const handleClickOk = useCallback(() => {
    const filter = update(form.getFieldsValue(), (draf) => {
      draf.contract_type =
        draf.contract_type.id === "all" ? null : draf.contract_type;

      draf.vehicle.branch =
        draf.vehicle.branch.code === "all" ? null : draf.vehicle.branch;

      draf.time =
        draf.time &&
        draf.time
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .format("x");
    });

    const query = {
      time: filter.time,
      filter: omit(filter, ["time"]),
      page: 1,
      size: 1000000,
    };

    form.submit();

    if (!!filter.time) {
      !!onOk && onOk(query);
      form.resetFields();
    }
  }, [onOk, form]);

  const handleCancel = useCallback(() => {
    !!onCancel && onCancel();
    form.resetFields();
  }, [onCancel, form]);

  return (
    <Modal
      onCancel={handleCancel}
      onOk={handleClickOk}
      width={600}
      title="Chọn tham số lọc báo cáo Overkm"
      visible={visible}
      okText="Lọc báo cáo"
      cancelText="Huỷ"
    >
      <Form
        labelAlign="left"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        form={form}
        initialValues={{
          time: moment(),
          contract_type: { id: "all" },
          prefix_code_in: null,
          driver: {
            id_in: null,
          },
          vehicle: {
            branch: {
              code: "all",
            },
            id_in: null,
          },
        }}
      >
        <Form.Item
          rules={[{ required: true, message: "Vui lòng chọn tháng" }]}
          label="Tháng"
          name="time"
        >
          <SelectMonth setFieldsValue={form.setFieldsValue} name="time" />
        </Form.Item>

        <Form.Item label="Chi nhánh xe" name={["vehicle", "branch", "code"]}>
          <ChiNhanhXe
            setFieldsValue={form.setFieldsValue}
            name="code"
            value={form.getFieldValue(["vehicle", "branch", "code"])}
          />
        </Form.Item>

        <Form.Item label="Loại hợp đồng" name={["contract_type", "id"]}>
          <LoaiHopDong
            setFieldsValue={form.setFieldsValue}
            name="contract_type"
            value={form.getFieldValue(["contract_type", "id"])}
          />
        </Form.Item>

        <Form.Item label="Số hợp đồng" name="prefix_code_in">
          <SoHopDong
            setFieldsValue={form.setFieldsValue}
            name="prefix_code_in"
          />
        </Form.Item>

        <Form.Item label="Biển KS xe" name={["vehicle", "id_in"]}>
          <BienKSXe setFieldsValue={form.setFieldsValue} name="vehicle" />
        </Form.Item>

        <Form.Item label="Tài xế" name="driver">
          <TaiXe setFieldsValue={form.setFieldsValue} name="driver" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(OverKmReportModal);
